const hostname = globalThis.location.hostname.toLowerCase();
/**
 * True when the domain running the code is a local domain.
 * @public
 */
export const isLOCAL = /^(localhost|0\.0\.0\.0|127\.0\.0\.1|.*\.local)$/i.test(hostname);
/**
 * True when the domain running the code is in the CI environment
 * @public
 */
export const isCI = /^lab(\d*($|\..*))/i.test(hostname);
/**
 * True when the domain running the code is in the DEMO environment
 * @public
 */
export const isDEMO = /^qa(\d*($|\..*))/i.test(hostname);
/**
 * True when the domain running the code is in the QED environment
 * @public
 */
export const isQED = /^sat(\d*($|\..*))/i.test(hostname);
/**
 * True when the domain running the code is in the PROD environment
 * @public
 */
export const isPROD = !isLOCAL && !isCI && !isDEMO && !isQED;
/**
 * True when the domain running the code is in the lower environment category
 * @public
 */
export const isLowerEnvironment = isCI || isDEMO || isQED;
/**
 * Readable name of the environment type (e.g. "PROD", "SAT", "QA", "LOCAL")
 * @public
 */
export const environmentName = isLOCAL
    ? 'LOCAL'
    : isCI
        ? 'LAB'
        : isDEMO
            ? 'QA'
            : isQED
                ? 'SAT'
                : 'PROD';
